module.exports = __webpack_public_path__ + "assets/img/2-3.c7fd1d3a.jpg";